/* Storefront v3 (the blend arm): header, menu, bag drawer on Shopify's cart, reveals, shared cards.
   The studio arm's script (v2-site.js) with the blend prototype's photos: cut-out mats in the cards, menu and bag,
   each print's own table on hover. Cart items added here carry the attribute storefront: v3. */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  EM.$ = $; EM.$$ = $$;
  const SIZE = { Two: 2, Four: 4, Six: 6 };
  const sizeOf = (v) => SIZE[v] || (EM.sets.find((s) => s.label === v) || {}).size || null;
  const cents = (n) => EM.money(Math.round(n / 100));

  /* ---------- menu ---------- */
  const menu = $("#menu");
  const menuPrints = $("[data-menu-prints]");
  const fillMenu = () => {
    if (!menuPrints || menuPrints.children.length) return;
    menuPrints.innerHTML = EM.prints.map((p) =>
      `<a href="${EM.url(p.slug)}"><img src="${EM.mat(p.slug, 160)}" alt="" width="62" height="62">${p.name}</a>`).join("");
  };
  let menuOpener = null;
  const setMenu = (open) => {
    if (!menu || menu.classList.contains("is-open") === open) return;
    menu.classList.toggle("is-open", open);
    menu.setAttribute("aria-hidden", String(!open));
    menu.inert = !open;
    $$("[data-menu-open]").forEach((b) => b.setAttribute("aria-expanded", String(open)));
    document.documentElement.style.overflow = open ? "hidden" : "";
    if (open) { fillMenu(); menuOpener = document.activeElement; setTimeout(() => menu.querySelector("[data-menu-close]").focus(), 60); }
    else if (menuOpener && menuOpener.focus) menuOpener.focus();
  };
  if (menu) menu.inert = true;
  $$("[data-menu-open]").forEach((b) => b.addEventListener("click", () => setMenu(true)));
  $$("[data-menu-close]").forEach((b) => b.addEventListener("click", () => setMenu(false)));

  /* ---------- delivery date from the shipping policy: leaves Miami the same or next business day, then USPS Ground Advantage
     in 2–5: 3 to 8 business days, skipping weekends and USPS holidays. ---------- */
  const HOLIDAYS = ["2026-11-11", "2026-11-26", "2026-12-25", "2027-01-01", "2027-01-18", "2027-02-15", "2027-05-31", "2027-06-18", "2027-07-05",
    "2027-09-06", "2027-10-11", "2027-11-11", "2027-11-25", "2027-12-24", "2027-12-31"];
  const ymd = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  const addBiz = (d, n) => { const x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (x.getDay() % 6 && !HOLIDAYS.includes(ymd(x))) n--; } return x; };
  EM.eta = () => {
    const now = new Date(), a = addBiz(now, 3), b = addBiz(now, 8);
    const m = (d) => d.toLocaleDateString("en-US", { month: "short" });
    return (a.getMonth() === b.getMonth() ? `${m(a)} ${a.getDate()}–${b.getDate()}` : `${m(a)} ${a.getDate()} – ${m(b)} ${b.getDate()}`).replace(/ /g, " ");
  };
  $$("[data-eta]").forEach((el) => (el.textContent = EM.eta()));

  /* ---------- collections ---------- */
  EM.collections = [["motifs", "Motifs"], ["stripes", "Stripes"], ["checks", "Checks"]];
  const ddBox = $("[data-dd]");
  if (ddBox) {
    ddBox.innerHTML = EM.collections.map(([k, n]) => {
      const discs = EM.prints.filter((p) => p.kind.toLowerCase() === k).slice(0, 3)
        .map((p) => `<img src="${EM.mat(p.slug, 160)}" alt="" loading="lazy" width="46" height="46">`).join("");
      return `<a href="${EM.home("#" + k)}"><span class="discs">${discs}</span>${n}</a>`;
    }).join("");
  }

  /* ---------- toast ---------- */
  const toastEl = $("[data-toast]");
  let toastT;
  EM.toast = (msg) => {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add("is-on");
    clearTimeout(toastT);
    toastT = setTimeout(() => toastEl.classList.remove("is-on"), 2600);
  };

  /* ---------- bag: Shopify's cart. Requests go through fetch so the theme's PostHog script sees them. ---------- */
  const api = (url, body) => fetch(url, body
    ? { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) }
    : { headers: { Accept: "application/json" } }).then((r) => r.json().then((j) => { if (!r.ok) throw j; return j; }));
  const drawer = $("#bag"), scrim = $("[data-scrim]");
  let cart = null;
  const variantsCache = {};
  const variantsFor = (handle) => (variantsCache[handle] = variantsCache[handle] || fetch(`/products/${handle}.js`).then((r) => r.json()).then((p) => p.variants));

  function lineImg(item) {
    return EM.bySlug[item.handle] ? EM.mat(item.handle, 240) : (item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, "$1$2") + (item.image.includes("?") ? "&" : "?") + "width=200" : "");
  }
  /* Instagram and Facebook on iPhone open the shop in their own browser, where Apple Pay is switched off (WebKit disables it when
     the host app injects scripts). Those shoppers get an honest payment line and a quiet way to finish the same bag in Safari:
     a Shopify cart permalink (/cart/<variant>:<qty>) goes straight to checkout there. x-safari-https:// is undocumented and has
     broken on some iOS versions, so the link is also copied, and a note says so if Safari didn't open. (CVR pass 2026-10-19) */
  const IOS_INAPP = /iPhone|iPad|iPod/.test(navigator.userAgent) && /Instagram|FBAN|FBAV|FB_IAB/.test(navigator.userAgent);
  /* Facebook and Instagram on Android open the shop in a WebView where the wallet buttons (Shop Pay, Google Pay) go nowhere:
     Oct 17-28, every Android in-app shopper who tapped them stalled. They get one plain Check out, no wallets, and an
     intent:// link that reopens the same bag in Chrome (browser_fallback_url keeps it working without Chrome). (2026-10-29) */
  const ANDROID_INAPP = /Android/.test(navigator.userAgent) && /Instagram|FBAN|FBAV|FB_IAB|FB4A/.test(navigator.userAgent);
  const INAPP = IOS_INAPP || ANDROID_INAPP;
  function handoffUrl(items, via = "safari") {
    const q = new URLSearchParams();
    q.set("attributes[storefront]", "v3");
    q.set("attributes[handoff]", via);
    try { const code = localStorage.getItem("em_offer_code"); if (code) q.set("discount", code); } catch (e) {} // the email offer's code (snippets/email-offer)
    if (cart && cart.note) q.set("note", cart.note);
    return `https://${location.host}/cart/${items.map((it) => `${it.variant_id}:${it.quantity}`).join(",")}?${q}`;
  }
  function chromeUrl(items) {
    const url = handoffUrl(items, "chrome");
    return `intent://${url.slice(8)}#Intent;scheme=https;package=com.android.chrome;S.browser_fallback_url=${encodeURIComponent(url)};end`;
  }
  if (INAPP) {
    const ex = $("[data-express]");
    if (ex) ex.textContent = "Shop Pay, PayPal or card at checkout";
  }
  if (ANDROID_INAPP) {
    document.addEventListener("click", (e) => {
      if (e.target.closest("[data-handoff-chrome]")) EM.track("chrome_handoff_clicked", { items: cart ? cart.item_count : 0, value: cart ? cart.total_price / 100 : 0 });
    });
  }
  if (IOS_INAPP) {
    document.addEventListener("click", (e) => {
      const a = e.target.closest("[data-handoff]");
      if (!a) return;
      e.preventDefault();
      const url = a.getAttribute("href");
      EM.track("safari_handoff_clicked", { items: cart ? cart.item_count : 0, value: cart ? cart.total_price / 100 : 0 });
      try { navigator.clipboard && navigator.clipboard.writeText(url).catch(() => {}); } catch (err) {}
      let left = false;
      const gone = () => { left = true; };
      document.addEventListener("visibilitychange", gone, { once: true });
      window.addEventListener("pagehide", gone, { once: true });
      location.href = "x-safari-" + url;
      setTimeout(() => { if (!left && document.visibilityState === "visible") EM.toast("Safari didn't open. The checkout link is copied: paste it into Safari to pay with Apple Pay."); }, 1600);
    });
  }

  function render() {
    const n = cart ? cart.item_count : 0;
    $$("[data-bag-count]").forEach((el) => { el.textContent = n; el.parentElement.hidden = n === 0; });
    $$("[data-bag-open]").forEach((b) => b.setAttribute("aria-label", n ? `Open bag, ${n} item${n > 1 ? "s" : ""}` : "Open bag"));
    if (!drawer || !cart) return;
    const items = cart.items;
    $("[data-ship-bar]").innerHTML = `<b>Free standard US shipping</b> on every set${items.length ? " · ships same or next business day" : ""}.`;
    $("[data-bag-lines]").innerHTML = items.length
      ? items.map((it) => {
          const size = sizeOf(it.variant_title);
          const per = size ? ` · ${cents(it.final_price / size)} a mat` : "";
          return `<div class="line">
            <img src="${lineImg(it)}" alt="" width="76" height="76">
            <div><h3>${it.product_title}</h3><p class="opts">${size ? `Set of ${size}` : it.variant_title || ""}${per}</p>
              <div class="qty"><button data-q="${it.key}" data-n="${it.quantity - 1}" aria-label="One fewer">−</button><span>${it.quantity}</span><button data-q="${it.key}" data-n="${it.quantity + 1}" aria-label="One more">+</button></div>
              <button class="rm" data-q="${it.key}" data-n="0">Remove</button></div>
            <div class="lp">${cents(it.final_line_price)}</div></div>`;
        }).join("") + `<div data-upsell></div><div data-gift-slot></div>`
      : `<div class="empty"><p>Your bag is empty.</p><a class="btn" href="${EM.home("#prints")}" data-bag-close>Browse the prints</a></div>`;
    $("[data-bag-foot]").innerHTML = items.length
      ? `<div class="sum"><span>Subtotal</span><span>${cents(cart.total_price)}</span></div>
         <p class="fine">Free standard shipping · Taxes at checkout</p>
         <a class="btn btn--block" href="/checkout">Check out · ${cents(cart.total_price)}</a>${IOS_INAPP ? `
         <p class="safari-handoff"><a href="${handoffUrl(items)}" data-handoff>Prefer Apple Pay? Finish in Safari</a></p>` : ""}${ANDROID_INAPP ? `
         <p class="safari-handoff"><a href="${chromeUrl(items)}" data-handoff-chrome>Checkout not opening? Finish in Chrome</a></p>` : ""}`
      : "";
    footEl.hidden = !items.length;
    const slot = $("[data-gift-slot]");
    if (slot) {
      slot.replaceWith(gift);
      if (document.activeElement !== noteEl) noteEl.value = cart.note || "";
      if (cart.note) gift.open = true;
    }
    upsell();
    wallets();
  }

  /* express checkout under the button: Shopify renders the wallets for the current cart (sections/v3-wallets.liquid).
     The plain line stays until they arrive, and stays for good if they can't. */
  const footEl = drawer ? drawer.querySelector("footer") : document.createElement("footer");
  const walletBox = $("[data-wallets]"), expressNote = $("[data-express]");
  let walletKey = "", walletReq = 0;
  function wallets() {
    if (!walletBox || !drawer.classList.contains("is-open")) return; // fetched when the bag is opened, not on every page
    if (INAPP) { walletBox.hidden = true; if (expressNote) expressNote.hidden = false; return; } // wallets don't work in Facebook/Instagram's browser
    const key = cart.item_count ? `${cart.token}|${cart.total_price}|${cart.item_count}` : "";
    if (key === walletKey) return;
    walletKey = key;
    const req = ++walletReq;
    if (!key) { walletBox.hidden = true; walletBox.innerHTML = ""; return; }
    if (walletBox.hidden && expressNote) expressNote.hidden = false;
    // no Accept: application/json here: with it, Shopify renders the wallets empty
    fetch("/?sections=v3-wallets")
      .then((r) => (r.ok ? r.json() : null))
      .then((j) => {
        if (req !== walletReq) return;
        const html = j && j["v3-wallets"];
        const ok = !!html && html.includes("shopify-accelerated-checkout-cart");
        if (ok) walletBox.innerHTML = html;
        walletBox.hidden = !ok;
        if (expressNote) expressNote.hidden = ok;
      })
      .catch(() => {});
  }

  /* gift note: Shopify's order note, saved as it's typed. One element, moved into each new render of the bag. */
  const gift = document.createElement("details");
  gift.className = "gift";
  gift.innerHTML = `<summary>Add a gift note</summary>
    <label class="sr-only" for="em-note">Gift note</label>
    <textarea id="em-note" rows="3" maxlength="300" placeholder="Your message"></textarea>
    <p class="note-state" data-note-state aria-live="polite"></p>`;
  const noteEl = gift.querySelector("textarea"), noteState = gift.querySelector("[data-note-state]");
  let noteT, noteTracked = false;
  const saveNote = () => {
    clearTimeout(noteT);
    const note = noteEl.value.trim();
    if (!cart || note === (cart.note || "")) return;
    noteState.textContent = "Saving…";
    api("/cart/update.js", { note }).then((c) => {
      cart.note = c.note;
      noteState.textContent = note ? "Saved to your order." : "";
      if (note && !noteTracked) { noteTracked = true; EM.track("gift_note_added", { length: note.length }); }
    }).catch(() => (noteState.textContent = "Couldn't save the note. Please try again."));
  };
  noteEl.addEventListener("input", () => { clearTimeout(noteT); noteT = setTimeout(saveNote, 800); });
  noteEl.addEventListener("change", saveNote);
  gift.addEventListener("toggle", () => { if (gift.open && !noteEl.value) setTimeout(() => noteEl.focus(), 30); });

  /* one quiet suggestion per bag, only when it saves money: the same number of mats of a print is cheaper as bigger sets
     (sixes first, then a four, then a two): offer the switch. (A "make it a set of 4" push on a lone set of 2 was removed
     2026-10-19: the only buyer so far bought a set of 2, and adders of 4s and 6s never bought.) */
  function cheapest(mats, price) {
    const out = [];
    let left = mats;
    while (left >= 6 && price[6]) { out.push(6); left -= 6; }
    if (left === 4 && price[4]) { out.push(4); left = 0; }
    while (left >= 2 && price[2]) { out.push(2); left -= 2; }
    return left ? null : out;
  }
  let plan = null;
  async function upsell() {
    const box = $("[data-upsell]");
    plan = null;
    if (!box || !cart) return;
    const groups = {};
    cart.items.forEach((it) => { const n = sizeOf(it.variant_title); if (n) (groups[it.handle] = groups[it.handle] || []).push(it); });
    for (const handle of Object.keys(groups)) {
      const lines = groups[handle];
      let vs;
      try { vs = await variantsFor(handle); } catch (e) { continue; }
      const price = {}, ids = {};
      vs.forEach((v) => { const n = sizeOf(v.title); if (n && v.available) { price[n] = v.price; ids[n] = v.id; } });
      const mats = lines.reduce((t, it) => t + sizeOf(it.variant_title) * it.quantity, 0);
      const now = lines.reduce((t, it) => t + it.final_line_price, 0);
      const best = cheapest(mats, price);
      const bestCost = best ? best.reduce((t, n) => t + price[n], 0) : now;
      const name = lines[0].product_title;
      if (best && bestCost < now) {
        plan = { [ids[2]]: 0, [ids[4]]: 0, [ids[6]]: 0 };
        best.forEach((n) => (plan[ids[n]] += 1));
        const sets = best.map((n) => `${n}`).join(" + ");
        box.innerHTML = `<button class="upsell" data-plan><span><b>Same ${mats} mats, ${cents(now - bestCost)} less</b> ${name} as ${best.length > 1 ? `sets of ${sets}` : `one set of ${best[0]}`} is ${cents(bestCost)}.</span><span class="add">Switch</span></button>`;
        return;
      }
    }
  }

  /* phone Back with the bag open closes the bag instead of leaving the page: opening it adds a history entry at the same
     address, closing it on the page takes that entry off again, and a link in the bag replaces it (see the click handler below) */
  if (history.state && history.state.bag) history.replaceState(null, ""); // reloaded from that entry: the bag starts closed
  const bagEntry = (open, how) => {
    if (how === "back" || how === "link") return;
    const mine = history.state && history.state.bag;
    try {
      if (open && !mine) history.pushState({ bag: true }, "");
      else if (!open && mine) history.back();
    } catch (e) { /* no history entry: Back leaves the page, as before */ }
  };
  addEventListener("popstate", (e) => { if (!(e.state && e.state.bag)) openBag(false, "back"); });

  let bagOpener = null;
  function openBag(open = true, how) {
    if (!drawer || drawer.classList.contains("is-open") === open) return;
    drawer.classList.toggle("is-open", open);
    scrim.classList.toggle("is-open", open);
    document.body.classList.toggle("bag-open", open); // the theme's PostHog script reports cart_viewed from this
    drawer.setAttribute("aria-hidden", String(!open));
    drawer.inert = !open;
    document.documentElement.style.overflow = open ? "hidden" : "";
    if (open) { bagOpener = document.activeElement; setTimeout(() => drawer.querySelector("[data-bag-close]").focus(), 60); if (cart) wallets(); }
    else if (bagOpener && bagOpener.focus) bagOpener.focus();
    bagEntry(open, how);
  }
  if (drawer) { drawer.inert = true; drawer.setAttribute("role", "dialog"); drawer.setAttribute("aria-modal", "true"); }
  EM.openBag = openBag;
  EM.refreshCart = () => api("/cart.js").then((c) => { cart = c; render(); return c; });

  let busy = false;
  EM.addToBag = (variantId, qty = 1, btn) => {
    if (busy) return Promise.resolve();
    busy = true;
    // say so at once ("Adding…"), and open the bag as soon as the cart has the item; the storefront tag follows in the background
    const label = btn && (btn.querySelector("[data-add-text]") || btn), was = label && label.textContent;
    if (btn) { btn.setAttribute("aria-busy", "true"); if (label) label.textContent = "Adding…"; }
    return api("/cart/add.js", { items: [{ id: +variantId, quantity: qty }] })
      .then(() => {
        if (!(cart && cart.attributes && cart.attributes.storefront === "v3")) api("/cart/update.js", { attributes: { storefront: "v3" } }).catch(() => {});
        return EM.refreshCart();
      })
      .then(() => openBag(true))
      .catch((err) => EM.toast((err && (err.description || err.message)) || "That couldn't be added. Please try again."))
      .finally(() => { busy = false; if (btn) { btn.removeAttribute("aria-busy"); if (label && label.textContent === "Adding…") label.textContent = was; } });
  };
  const change = (key, quantity, label) => api("/cart/change.js", { id: key, quantity }).then((c) => {
    cart = c; render();
    const again = label && drawer.querySelector(`button[data-q="${CSS.escape(key)}"][aria-label="${label}"]`);
    (again || drawer.querySelector("[data-bag-close]")).focus();
  }).catch(() => EM.toast("Couldn't update the bag. Please try again."));

  document.addEventListener("click", (e) => {
    const t = e.target.closest("[data-q],[data-bag-open],[data-bag-close],[data-scrim],[data-plan]");
    if (!t) return;
    if (t.matches("[data-bag-open]")) { openBag(true); if (!cart) EM.refreshCart(); return; }
    if (t.matches("[data-bag-close],[data-scrim]")) { openBag(false, t.matches("a[href]") ? "link" : ""); return; }
    if (t.matches("[data-q]")) { change(t.dataset.q, Math.max(0, +t.dataset.n), t.getAttribute("aria-label")); return; }
    if (t.matches("[data-plan]") && plan) {
      // one request sets the final number of each set size for that print
      const updates = {};
      Object.keys(plan).forEach((id) => { if (id !== "undefined") updates[id] = plan[id]; });
      t.disabled = true;
      api("/cart/update.js", { updates })
        .then((c) => { cart = c; render(); drawer.querySelector("[data-bag-close]").focus(); EM.track("bag_suggestion_taken", { updates }); })
        .catch(() => { EM.toast("Couldn't update the bag. Please try again."); EM.refreshCart(); });
    }
  });
  scrim && scrim.addEventListener("click", () => openBag(false));
  // a link in the bag (Check out, Browse the prints) takes over the bag's history entry, so Back from checkout comes straight
  // back to this page; links another handler took (the Safari hand-off) and other sites (the Chrome hand-off) are left alone
  document.addEventListener("click", (e) => {
    const a = e.target.closest("a[href]");
    if (!a || !drawer || !drawer.contains(a) || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (a.origin !== location.origin || (a.target && a.target !== "_self") || !(history.state && history.state.bag)) return;
    e.preventDefault();
    location.replace(a.href);
  });
  addEventListener("keydown", (e) => {
    if (e.key === "Escape") { openBag(false); setMenu(false); return; }
    if (e.key !== "Tab") return;
    const box = drawer && drawer.classList.contains("is-open") ? drawer : menu && menu.classList.contains("is-open") ? menu : null;
    if (!box) return;
    const f = $$('a[href], button:not([disabled]), input, textarea, summary, [tabindex]:not([tabindex="-1"])', box).filter((el) => el.offsetParent !== null && !el.matches("[data-focus-end]"));
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    // the wallet buttons after the last link live in Shopify's own elements: let Tab reach them (the sentinel below brings focus back)
    else if (!e.shiftKey && document.activeElement === last && !(box === drawer && walletBox && !walletBox.hidden)) { e.preventDefault(); first.focus(); }
  });
  // Tab past the last wallet button lands on this sentinel, which sends focus back to the top of the bag.
  // (A focus guard on the whole document would also pull focus out of PayPal's or Shop Pay's own overlays.)
  const focusEnd = $("[data-focus-end]");
  focusEnd && focusEnd.addEventListener("focus", () => drawer.querySelector("[data-bag-close]").focus());
  // the cart is fetched once the page has painted (it also seeds the analytics script's cart)
  const idle = window.requestIdleCallback || ((f) => setTimeout(f, 600));
  idle(() => EM.refreshCart().catch(() => {}));
  // coming back to the page from checkout restores it from the back/forward cache: refresh the bag
  addEventListener("pageshow", (e) => { if (e.persisted) EM.refreshCart().catch(() => {}); });

  /* ---------- reveal on scroll ---------- */
  EM.observeReveals = (root = document) => {
    const els = $$(".reveal:not(.is-in)", root);
    if (!("IntersectionObserver" in window)) { els.forEach((el) => el.classList.add("is-in")); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add("is-in"); io.unobserve(en.target); } });
    }, { rootMargin: "0px 0px -12% 0px", threshold: 0.08 });
    els.forEach((el) => io.observe(el));
  };
  EM.setExploded = () => {}; // the studio arm's up-close panel is not on these pages

  /* ---------- shared print card: the cut-out mat on a soft grey square, its own table on hover ---------- */
  const canHover = matchMedia("(hover: hover) and (pointer: fine)").matches;
  EM.cardSizes = "(min-width: 1180px) 23vw, (min-width: 760px) 31vw, 48vw";
  // priced as a set, with the count, so nobody reads it as one mat; the card opens on that set
  EM.card = (p, i = 0, price = EM.setFor(2).price, size = 2) => `
    <a class="print-card reveal reveal-d${i % 4}" href="${EM.url(p.slug, size)}" data-kind="${p.kind}">
      <div class="tile">
        <img class="disc" src="${EM.mat(p.slug, 800)}" srcset="${EM.mat(p.slug, 420)} 420w, ${EM.mat(p.slug, 800)} 800w, ${EM.mat(p.slug, 1400)} 1400w" sizes="${EM.cardSizes}" alt="${p.name} round acrylic placemat" loading="lazy" width="1400" height="1400">
        ${canHover ? `<img class="set" src="${EM.half(p.slug, "l", 1000)}" srcset="${EM.half(p.slug, "l", 600)} 600w, ${EM.half(p.slug, "l", 1000)} 1000w, ${EM.half(p.slug, "l", 1600)} 1600w" sizes="${EM.cardSizes}" alt="${p.name} ${p.line.toLowerCase()} placemats on a laid table" loading="lazy" width="1000" height="1117">` : ""}
      </div>
      <div class="meta"><h3>${p.name}</h3><span class="price">${EM.money(price)} for ${size}</span></div>
    </a>`;

  /* a small fan of real mats: how many you get, at a glance */
  EM.fan = (slug, n) => `<span class="fan" data-n="${n}" aria-hidden="true">${Array.from({ length: n }, () => `<img src="${EM.mat(slug, 160)}" alt="" width="80" height="80" loading="lazy">`).join("")}</span>`;

  document.addEventListener("DOMContentLoaded", () => EM.observeReveals());
  if (document.readyState !== "loading") EM.observeReveals();
})();
